import { Button } from '@music-vine/cadence/ui';
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
interface PopupActionsProps {
  children: ReactNode;
  className?: string;
  onNotInterested?: () => void;
  onRemindLater?: () => void;
  reoccurring?: boolean;
}
export const PopupActions = ({
  children,
  className,
  reoccurring,
  onRemindLater,
  onNotInterested
}: PopupActionsProps) => <div className={cn('flex flex-col gap-4', className)} data-sentry-component="PopupActions" data-sentry-source-file="PopupActions.tsx">
    {reoccurring ? <>
        {children}
        <div className="flex w-full flex-col justify-between gap-3">
          <Button border className="flex-0" onClick={onRemindLater} variant="subtle">
            Remind me later
          </Button>
          <Button className="flex-0 text-sm" onClick={onNotInterested} variant="transparent">
            No thanks
          </Button>
        </div>
      </> : <div className="flex w-full items-center justify-end gap-3">
        {children}
      </div>}
  </div>;
export type { PopupActionsProps };